import { apiGet } from './api';
import { API_URL } from './authServices';

/** Guilds no painel do jogador (Cabal Next, dono 2026-10-22) -- next_api app/guild/routes.py. */
export interface GuildCard {
  guildNo: number;
  name: string;
  level: number;
  point: number;          // pontos da guild (Guild.Point)
  members: number;
  warPoints: number;      // soma dos pontos de guerra dos membros
  warKills: number;       // soma das kills de guerra dos membros
  emblemUrl: string | null;
  myChars: string[];      // personagens da conta nessa guild
  isMaster: boolean;      // um personagem da conta e' o mestre
}

export interface GuildMember {
  name: string;
  classId: number;
  level: number;
  overlord: number;
  master: boolean;
  online: boolean;
  warPoints: number;
  warKills: number;
  mine: boolean;          // personagem da conta logada
}

export interface EmblemRules {
  width: number;
  height: number;
  maxBytes: number;
  cooldownDays: number;
}

export interface GuildDetail extends GuildCard {
  memberList: GuildMember[];
  emblemWaitSeconds: number;   // > 0 = ainda na trava de 7 dias
  emblemRules: EmblemRules;
}

export interface EmblemResult {
  message: string;
  emblemUrl: string | null;
  emblemWaitSeconds: number;
}

/** GET /Guild/mine -- guilds dos personagens da conta */
export const getMyGuilds = () => apiGet<GuildCard[]>('/Guild/mine');

/** GET /Guild/{no} -- detalhe + membros */
export const getGuild = (guildNo: number) => apiGet<GuildDetail>(`/Guild/${guildNo}`);

/** POST /Guild/{no}/emblem -- multipart "file" (so' o mestre; PNG no tamanho exato; trava de 7 dias) */
export async function uploadGuildEmblem(guildNo: number, file: File): Promise<EmblemResult> {
  const raw = localStorage.getItem('liberty_auth');
  let token = '';
  try { token = raw ? JSON.parse(raw).token : ''; } catch { /* ignore */ }
  const fd = new FormData();
  fd.append('file', file);
  const res = await fetch(`${API_URL}/Guild/${guildNo}/emblem`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
    body: fd,
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ message: 'Erro no envio do emblema.' }));
    throw err;
  }
  return res.json();
}
